var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"section--amenity"},[_c('div',{staticClass:"row"},_vm._l((_vm.amenities),function(item,k){return _c('div',{key:k,staticClass:"col-12 col-md-6"},[_c('ul',{staticClass:"amenity--item ma-0"},[_c('li',[_vm._v(_vm._s(item))])])])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }